export class StoryLine {
    constructor(options, source, target) {
        this.options = options;
        this.source = source;
        this.target = target;
    }
}
export class StoryInputLine extends StoryLine {
    constructor(options, source, target) {
        super(options, source, target);
        this.options = options;
        this.source = source;
        this.target = target;
    }
}
export class StoryOutputLine extends StoryLine {
    constructor(options, source, target) {
        super(options, source, target);
        this.options = options;
        this.source = source;
        this.target = target;
    }
}
/// 因clean操作清空group的子节点，而断连的line
export class StoryDisconnectedLine {
    constructor(parentId, indexInParent, lines) {
        this.parentId = parentId;
        this.indexInParent = indexInParent;
        this.lines = lines;
    }
}
